// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type Props = {
    parameters: {
        withCoverPage?: boolean;
        withTableOfContent?: boolean;
        withAboutUs?: boolean;
        withSpecSheet?: boolean;
        productsInlineFormat?: boolean;
        preparedFor?: string;
        consultant?: string;
        projectName?: string;
        phone?: string;
        pdfType?: "quote" | "wishlist";
        id?: string;
        ThirdPartyQuoteClientName?: string;
        ThirdPartyQuoteClientStreetAddress1?: string;
        ThirdPartyQuoteClientStreetAddress2?: string;
        ThirdPartyQuoteClientCity?: string;
        ThirdPartyQuoteClientProvince?: string;
        ThirdPartyQuoteClientPostalCode?: string;
        ThirdPartyQuoteWebsite?: string;
        ThirdPartyQuoteClientEmail?: string;
        ThirdPartyQuoteClientPhoneNumber?: string;
        ThirdPartyQuoteFreightCharges?: number;
        ThirdPartyQuoteLabourCharges?: number;
        ThirdPartyQuoteTaxDisplayOption?: "Hst" | "Gst" | "NoTax";
        ThirdPartyQuotePriceDisplayOption?: "ShowProductPrices" | "HideProductPrices";
        ThirdPartyQuoteExpirationDate?: string;
        includePrice?: boolean;
        generalNotes?: string;
    };
};

type HandlerType = Handler<any, Props>;

export const UpdatePdfSettings: HandlerType = props => {
    props.dispatch({
        type: "PdfSettings/UpdatePdfSettings",
        value: props.parameter.parameters,
    } as any);
};

export const chain = [UpdatePdfSettings];

const updatePdfSettings = createHandlerChainRunner(chain, "UpdatePdfSettings");
export default updatePdfSettings;
